import { render, staticRenderFns } from "./PaymentLogs.vue?vue&type=template&id=08d18dc6&"
import script from "./PaymentLogs.vue?vue&type=script&lang=js&"
export * from "./PaymentLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports